var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerControlEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83C36D"
    },
    className: "st0",
    d: "M1.2,333.7v332.5h221.7L500,943.4V56.6L222.9,333.7H1.2z M749.4,500c0-97.8-56.5-182.3-138.5-223.1v446.4 C692.9,682.3,749.4,597.8,749.4,500z M610.8,14v114.4C771,176.1,888,324.3,888,500S771,823.9,610.8,871.6V986 c222-50.4,388-248.6,388-486S832.8,64.4,610.8,14z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerControlEnergy);
export default __webpack_public_path__ + "static/media/speakerControlEnergy.441bf9e7620edd981dcaa2526b3403d0.svg";
export { ForwardRef as ReactComponent };